/*
  Store module for Unified App configuration
*/

// State
export const state = () => ({
  isLoading: false,
  isUnifiedApp: false,
  unifiedAppVersion: '',
})

// Getters
export const getters = {
  isUnifiedAppEnabled: (state) => {
    return state.isUnifiedApp
  },
  getUnifiedAppVersion: (state) => {
    return state.unifiedAppVersion
  },
}

// Mutations
export const mutations = {
  SET_IS_LOADING(state, value) {
    state.isLoading = value
  },
  SET_UNIFIED_APP_CONFIG(state, { isUnifiedApp, unifiedAppVersion }) {
    state.isUnifiedApp = isUnifiedApp
    state.unifiedAppVersion = unifiedAppVersion
  },
}
